export { getBasketServerAction } from 'next-flight-server-reference-proxy-loader?id=40dcd63ab424d03f76e4d3f2eb369decb51019fb90&name=getBasketServerAction!'